export default "__VITE_ASSET__D9FJx96k__"